













import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ChartHeader from './ChartHeader.vue'

  @Component({
    name: 'BarSTD',
    components: { Chart, ChartHeader }
  })
export default class extends Vue {
    @Prop({ default: '#FFA100' }) private color!: string
    @Prop({ required: true }) private dataList!: Array<any>

    private legend: any[] = [{ name: '参考标准', color: '#AEAEAE' }, { name: '标准差', color: '#F87A52' }, { name: '均分', color: '#FFA100' }]
    private chartId: string = ''
    private yData: Array<string> = []
    private xData: Array<any> = []
    private markData: Array<any> = []
    // private lineData: Array<any> = []
    private option: any = {
      animation: false,
      grid: {
        left: 120,
        bottom: 20
        // show: false
        // containLabel: true
      },
      xAxis: {
        position: 'top',

        axisLine: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#999999'
        },
        name: '',
        max: 100
      },
      yAxis: {
        data: [],
        nameTextStyle: {
          fontSize: 10
        },
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      series: [
        {
          name: '均值',
          type: 'bar',
          data: [],
          itemStyle: {
            color: '#FFA100',
            barBorderRadius: 10
          },
          barWidth: 10,
          markLine: {
            itemStyle: {
              color: '#AEAEAE'
            },
            label: {
              show: false,
              position: 'start'
            },
            symbol: ['none', 'none'],
            lineStyle: {
              width: 1
            },
            data: [
              {
                name: '0',
                xAxis: []
              }
            ]
          }
        },
        {
          name: '标准差',
          type: 'custom',
          renderItem: this.renderItem,
          encode: {
            x: 0,
            y: [1, 2]
          },
          itemStyle: {
            color: '#F87A52',
            borderType: 'dotted'
          },
          data: [],
          z: 100
        }
      ]
    }

    get chart() {
      return this.$refs.chart as any
    }
    @Watch('dataList', { immediate: true, deep: true })
    onDataChange(val: any) {
      if (!this.dataList.length) return
      this.xData = []
      this.yData = []
      this.markData = []
      // this.xData.reverse()
      let barList = JSON.parse(JSON.stringify(this.dataList)).reverse()
      barList.map((item: any, index: number) => {
        // this.yData.push(item.classroomName.substring(0, 3))
        this.yData.push(item.name)
        // 均分
        let mean = parseFloat(item.values[4] || 0)
        // 标准差
        let standardDeviation = parseFloat(item.values[3] || 0)
        this.xData.push(mean || 0)
        this.markData.push([index, mean - standardDeviation / 2, mean + standardDeviation / 2])
      })
      // console.log(this.xData)
      // console.log(this.yData)
      // console.log(this.markData)
      this.option.yAxis.data = this.yData
      // x轴数据
      this.option.series[0].data = this.xData
      // 参考标准-常模
      this.option.series[0].markLine.data[0].xAxis = barList[0].values[5]
      //
      this.option.series[1].data = this.markData
      this.$nextTick(() => {
        this.setOption()
      })
    }
    created() {
      this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    }

    private renderItem(params:any, api:any) {
      // console.log(api.value(1))
      // console.log(api.value(2))
      var yIndex = api.value(0)
      var start = api.coord([api.value(1), yIndex])
      var end = api.coord([api.value(2), yIndex])
      // var height = api.size([0, 1])[1] * 0.6;
      // var highPoint = api.coord([yIndex, api.value(1)]);
      // var lowPoint = api.coord([yIndex, api.value(2)]);
      var halfWidth = api.size([1, 0])[0] * 1
      var style = api.style({
        stroke: api.visual('color'),
        fill: null
      })

      return {
        type: 'group',
        children: [{
          type: 'line',
          transition: ['shape'],
          shape: {
            x1: start[0],
            y1: start[1] - halfWidth,
            x2: start[0],
            y2: start[1] + halfWidth
          },
          style: style
        }, {
          type: 'line',
          transition: ['shape'],
          shape: {
            x1: start[0],
            y1: start[1] - halfWidth,
            x2: end[0],
            y2: end[1] - halfWidth
          },
          style: style
        }, {
          type: 'line',
          transition: ['shape'],
          shape: {
            x1: start[0],
            y1: start[1] + halfWidth,
            x2: end[0],
            y2: end[1] + halfWidth
          },
          style: style
        }, {
          type: 'line',
          transition: ['shape'],
          shape: {
            x1: end[0],
            y1: end[1] - halfWidth,
            x2: end[0],
            y2: end[1] + halfWidth
          },
          style: style
        }]
      }
    }

    private setOption() {
      this.chart.setOption(this.option)
    }
}
